module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-01-m-en.32c89434017aa753ee09a9f18474660e.png";